var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import cn from "classnames";
import { useCSSTransition, } from "@react-md/transition";
import { bem } from "@react-md/utils";
var block = bem("rmd-tab-panel");
var prefix = "rmd-tab-panel";
/** @remarks \@since 4.0.0 */
export var DEFAULT_TABPANEL_TIMEOUT = 150;
/** @remarks \@since 4.0.0 */
export var DEFAULT_TABPANEL_CLASSNAMES = {
    enter: "".concat(prefix, "--enter"),
    enterActive: "".concat(prefix, "--enter-active ").concat(prefix, "--animate"),
    exit: "".concat(prefix, "--exit"),
    exitActive: "".concat(prefix, "--exit-active ").concat(prefix, "--animate"),
};
/**
 * This component renders an accessible tab panel with enter and exit
 * animations.  This probably should only be used internally as it relies on the
 * `TabPanels` component along with the `TransitionGroup` from
 * `react-transition-group` to work as expected.
 */
export var TabPanel = forwardRef(function TabPanel(_a, nodeRef) {
    var propClassName = _a.className, appear = _a.appear, enter = _a.enter, exit = _a.exit, onEnter = _a.onEnter, onEntering = _a.onEntering, onEntered = _a.onEntered, onExit = _a.onExit, onExiting = _a.onExiting, onExited = _a.onExited, _b = _a.timeout, timeout = _b === void 0 ? DEFAULT_TABPANEL_TIMEOUT : _b, _c = _a.classNames, classNames = _c === void 0 ? DEFAULT_TABPANEL_CLASSNAMES : _c, _d = _a.transitionIn, transitionIn = _d === void 0 ? true : _d, temporary = _a.temporary, children = _a.children, hidden = _a.hidden, props = __rest(_a, ["className", "appear", "enter", "exit", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "timeout", "classNames", "transitionIn", "temporary", "children", "hidden"]);
    var _e = useCSSTransition({
        nodeRef: nodeRef,
        timeout: timeout,
        classNames: classNames,
        className: cn(block(), propClassName),
        transitionIn: transitionIn && !hidden,
        appear: appear,
        enter: enter,
        exit: exit,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: onExited,
        temporary: temporary,
    }), elementProps = _e.elementProps, rendered = _e.rendered;
    if (!rendered) {
        return null;
    }
    return (_jsx("div", __assign({}, props, elementProps, { role: "tabpanel", hidden: hidden }, { children: children }), void 0));
});
//# sourceMappingURL=TabPanel.js.map